import 'vite/modulepreload-polyfill';

import './sentry';
import Outdated from './components/Outdated';
import LazyPopover from './components/LazyPopover';
import LoadMore from './components/LoadMore';
import SectionTracker from './components/SectionTracker';
import GoogleTracking from './components/tracking/GoogleTracking';
import SensorsDataTracking from './components/tracking/SensorsDataTracking';
import Notification from './components/Notification';
import Cookies from 'js-cookie';
import { route as laravelRoute } from 'ziggyRoute';
import store from '@phoenix/store';
import { emitter } from '@phoenix/event-bus';
import { ComponentRegistry } from '@sg/resources/assets/js/utils';

// Maison related imports
import * as Toolkit from '@maison/Toolkit';

new Outdated();
new LoadMore();
new SectionTracker('.rcms_anchor');
const tracking = window.Phoenix.trackingVariables.isSensorsDataActivated
  ? new SensorsDataTracking()
  : new GoogleTracking();

window.Phoenix.notification = new Notification();
window.Phoenix.components = new ComponentRegistry();
window.Phoenix.emit = (eventName, payload) => {
  emitter.emit(eventName, payload);
};

Object.assign(window, {
  route: laravelRoute,
  tracking,
  Toolkit,
  emitter,
  LazyPopover,
  Cookies,
});

document.addEventListener('DOMContentLoaded', () => {
  store.dispatch('currentUser/loadCustomerInfo');
});
